import {useEffect} from 'react';

import {PeepDuplicateBadge} from '../../shared/header/peep-duplicate-badge';

import {useGetContactDuplicateStatus} from '../graphql/hooks/use-get-contact-duplicate-status';

interface Props {
    contactId: string;
}

export function ContactDuplicateWrapper(props: Props) {
    const {contactDuplicateStatus, isLoading, refetch} = useGetContactDuplicateStatus(
        props.contactId
    );

    useEffect(() => {
        const handleDuplicateStatusUpdate = () => {
            refetch();
        };

        $('body').on(Nut.events.card.duplicateStatusWasUpdated, handleDuplicateStatusUpdate);

        return () => {
            $('body').off(Nut.events.card.duplicateStatusWasUpdated, handleDuplicateStatusUpdate);
        };
    }, [refetch]);

    if (isLoading || !contactDuplicateStatus || !contactDuplicateStatus.hasDuplicates) {
        return null;
    }

    return (
        <PeepDuplicateBadge
            entityName='Contacts'
            entityId={props.contactId}
            parentEntityName='Accounts'
        />
    );
}
